module.exports = __webpack_public_path__ + "img/HQ-PS24-V2_V20_ALL.db3ba3fd.jpg";